export default ['Access_bank', 'top_up'];
